var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _vm.$wf.isSmDown
        ? _c(
            "app-toolbar",
            [
              _c(
                "w-toolbar-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "save" } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-container",
        { staticClass: "w100", attrs: { "no-margin": "" } },
        [
          _c(
            "w-breadcrumb",
            { attrs: { crumbs: _vm.path } },
            [
              _c("w-spacer"),
              _vm.$wf.isMdUp
                ? _c(
                    "w-button",
                    {
                      attrs: { icon: "save", disabled: !_vm.isValid },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.config
            ? _c(
                "w-scroll-view",
                { attrs: { tag: "w-container" } },
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-tabs", {
                            attrs: {
                              disabled: !_vm.isValid,
                              tabs: _vm.tabs,
                              value: _vm.tab,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onTab($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "transition",
                    { attrs: { mode: "out-in", name: "fast-fade" } },
                    [
                      _vm.tab == 0
                        ? _c("app-reminder-settings", {
                            attrs: {
                              config: _vm.config,
                              "user-config": _vm.userConfig,
                            },
                          })
                        : _vm._e(),
                      _vm.tab == 1
                        ? _c("app-reminder-documents", {
                            attrs: {
                              layouts: _vm.layouts,
                              templates: _vm.templates,
                            },
                            on: {
                              "update-layouts": function ($event) {
                                return _vm.updateLayouts()
                              },
                              "restore-email-templates": _vm.restoreTemplates,
                            },
                          })
                        : _vm._e(),
                      _vm.tab == 2
                        ? _c("app-reminder-emails", {
                            attrs: { "email-templates": _vm.emailTemplates },
                            on: {
                              "update-email-templates": function ($event) {
                                return _vm.updateEmailTemplates()
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }